import axiosInstance from "@/axiosConfig";
import type { ImpactReport } from "@/shared/types/resourceUsage.types";
import { getApiUrl } from "@/shared/utils/api";

export type PlannedMutation = {
  resource_type: string
  resource_id: string
  kind: "rename" | "delete" | "retype"
};

/**
 * ADM-856: previews the aggregated cross-feature impact of a batch of planned
 * mutations WITHOUT applying anything, so a multi-op save can confirm before it
 * partially lands. Returns an empty report when nothing is impacted.
 */
export async function previewResourceUsage(mutations: PlannedMutation[]): Promise<ImpactReport> {
  const response = await axiosInstance.post<{ impact_report: ImpactReport }>(
    getApiUrl("/resource_usage/preview"),
    { mutations },
  );
  return response.data.impact_report;
}
